import {useEffect} from 'react'

import {dispatch, useSelector} from '../../store.js'
import {ORDER_DETAIL_PAGE} from '../../common/constants/Pages.js'
import {setCurrentPage} from '../../redux/actions/ui/index.js'
import {
  setupOrderDetailForm,
  removeOrderDetailForm,
  loadOrderDetailOrder,
} from './orderDetailActions.js'
import {DETAIL_MODE} from '../../common/constants/index.js'
import {orderListQuerySelector} from '../OrderListPage/orderListSelectors.js'
import {orderSelector} from '../../data/orders.js'

export default function OrderDetailLocationListener() {
  const {mode, orderNumber} = useSelector(orderListQuerySelector)
  const order = useSelector((state) =>
    orderNumber ? orderSelector(state, {orderNumber}) : null,
  )

  useEffect(() => {
    if (mode !== DETAIL_MODE || !orderNumber) {
      return
    }

    dispatch(setCurrentPage(ORDER_DETAIL_PAGE))

    setupOrderDetailForm()

    loadOrderDetailOrder()

    return () => removeOrderDetailForm()
  }, [mode, orderNumber, order])

  return null
}
